<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<label class="fancy-control-checkbox">
	<input
		type="checkbox"
		[formControl]="internalCheckbox"
		style="display: none"
		class="fancy-checkbox-input-zindex"
	/>
	<div class="control-indicator">
		<i class="material-icons check-icon">done</i>
	</div>
	<ng-content></ng-content>
</label>
